import { render, staticRenderFns } from "./MainEarning.vue?vue&type=template&id=2132d9a8"
import script from "./MainEarning.vue?vue&type=script&lang=js"
export * from "./MainEarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports